<template>
  <div class="container">
    <nav-bar />
    <div class="outer-container gray-3 bg">    
      <side-nav :has-back-button="hasBack" :back-label="'Return to assignments'" @onBack="returnToAssignments" />
      <router-view />
    </div>
    <bottom-bar :can-create="!hasBack" :can-save="false" @newAssignment="newAssignment" />
  </div>
</template>

<script>
import NavBar from '~lib/common/components/NavBar';
import SideNav from '~lib/common/components/SideNav';
import BottomBar from '../components/assignments/BottomBar';

export default {
  name: 'assignments-screen',
  components: {
    NavBar,
    SideNav,
    BottomBar,
  },
  computed: {
    hasBack() {
      return this.$route.fullPath.includes('edit');
    },
  },
  mounted() {
    this.$analytics.event('Assignments', 'assignments_page');
  },
  methods: {
    returnToAssignments() {
      this.$router.go(-1);
    },
    newAssignment() {
      this.$router.push({ 
        name: 'assignment-editor', 
        params: { assignmentId: 'new' }
      });
    },
  },
};
</script>

<style scoped>
.container {
  height: 100%;
}

.outer-container {
  flex: 1 0 0;
  display: flex;
  flex-direction: row;
  height: calc(100% - 153px);
  overflow-x: auto;
}

.side-nav {
  width: 15%;
}
</style>
